import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const SET_WORKFLOW_DATA = 'SET_WORKFLOW_DATA';
export const SET_APPS_WORKSPACES = 'SET_APPS_WORKSPACES';
export const REMOVE_WORKFLOW = 'REMOVE_WORKFLOW';
export const ADD_NODE_TO_WORKFLOW_NODES = 'ADD_NODE_TO_WORKFLOW_NODES';
export const SET_WORKFLOW_SHARED_DATA = 'SET_WORKFLOW_SHARED_DATA';
export const SET_WORKFLOW_SHARED_DATA_LOADING = 'SET_WORKFLOW_SHARED_DATA_LOADING';
export const SET_SHARED_WORKFLOWS = 'SET_SHARED_WORKFLOWS';
export const SET_WAITING_FOR_SAMPLE_DATA = 'SET_WAITING_FOR_SAMPLE_DATA';
export const SET_UPDATING_WORKFLOW = 'SET_UPDATING_WORKFLOW';
export const SET_IS_LOADING_WORKFLOW_GRAPH = 'SET_IS_LOADING_WORKFLOW_GRAPH';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_WORKFLOW_DATA](state, payload) {
		const { key, value } = payload;
		Vue.set(state.data, key, value);
	},
	[SET_APPS_WORKSPACES](state, payload) {
		const { appsWorkspaces } = payload;
		Vue.set(state, 'appsWorkspaces', appsWorkspaces);
	},
	[REMOVE_WORKFLOW](state, payload) {
		const { id } = payload;
		Vue.delete(state.data, id);
	},
	[ADD_NODE_TO_WORKFLOW_NODES](state, payload) {
		const { id: workflowId, nodeId } = payload;
		state.data[workflowId].current_draft.nodes.push(nodeId);
	},
	[SET_WORKFLOW_SHARED_DATA](state, payload) {
		const { key, value } = payload;
		Vue.set(state.sharedData, key, value);
	},
	[SET_WORKFLOW_SHARED_DATA_LOADING](state, payload) {
		const { isLoading } = payload;
		Vue.set(state, 'sharedDataLoading', isLoading);
	},
	[SET_SHARED_WORKFLOWS](state, payload) {
		const { workflows } = payload;
		Vue.set(state, 'sharedWorkflows', workflows);
	},
	[SET_IS_LOADING_WORKFLOW_GRAPH](state, isLoading) {
		Vue.set(state, 'isLoadingWorkflowGraph', isLoading);
	},
	[SET_WAITING_FOR_SAMPLE_DATA](state, { workflowId, isWaiting }) {
		let newIds = [...state.waitingForSampleDataWorkflowIds];
		if (isWaiting) {
			newIds.push(workflowId);
		} else {
			newIds = newIds.filter((id) => id !== Number(workflowId));
		}
		Vue.set(state, 'waitingForSampleDataWorkflowIds', [...new Set(newIds)]);
	},
	[SET_UPDATING_WORKFLOW](state, payload) {
		Object.entries(payload).forEach(([id, isUpdating]) => {
			id = Number(id);
			if (isUpdating) {
				state.updatingWorkflowIds.push(id);
			} else {
				state.updatingWorkflowIds = state.updatingWorkflowIds.filter((workflowId) => workflowId !== id);
			}
		});
	},
};

export default mutations;
